// Typed wrapper around /api/track_inputs (Phase 8.5b selector view-model).
// Wire shape is validated through the Zod schemas in ./schemas. This is the
// product-level "track input" list (track/layout-first, with the recommended
// source + alternates + confidence); /api/cached_events stays the lower-level
// per-source inventory the detail panel and create flow resolve against.
import { z } from "zod";
import {
  StudyRecipeSchema,
  TrackInputSchema,
  type StudyRecipe,
  type TrackInput,
} from "./schemas";

export type { StudyRecipe, TrackInput };

const TrackInputListSchema = z.array(TrackInputSchema);

export async function listTrackInputs(): Promise<TrackInput[]> {
  const r = await fetch("/api/track_inputs");
  if (!r.ok) throw new Error(`GET /api/track_inputs failed: ${r.status}`);
  return TrackInputListSchema.parse(await r.json());
}

// Fable P3 recipe rail: the four-input pre-create resolution for one venue.
export async function fetchTrackInputRecipe(key: string): Promise<StudyRecipe> {
  const r = await fetch(`/api/track_input_recipe?key=${encodeURIComponent(key)}`);
  if (!r.ok) throw new Error(`GET /api/track_input_recipe failed: ${r.status}`);
  return StudyRecipeSchema.parse(await r.json());
}
